var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-svg": "false",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13707 -13988.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M-13706,13995.5c-0.5527,0-1-0.4473-1-1v-5c0-0.5527,0.4473-1,1-1s1,0.4473,1,1v5 C-13705,13995.0527-13705.4473,13995.5-13706,13995.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M-13706,13998.5c-0.2695,0-0.5195-0.1006-0.71-0.29c-0.1904-0.1904-0.29-0.4404-0.29-0.71 c0-0.1299,0.0293-0.2598,0.0801-0.3799c0.0498-0.1299,0.1191-0.2305,0.21-0.3301c0.3701-0.3701,1.04-0.3701,1.4199,0 c0.0898,0.0996,0.1592,0.21,0.21,0.3301c0.0498,0.1201,0.0801,0.25,0.0801,0.3799s-0.0303,0.2598-0.0801,0.3799 c-0.0508,0.1201-0.1201,0.2295-0.21,0.3301C-13705.4805,13998.3994-13705.7305,13998.5-13706,13998.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.eb3177e4.svg";
export { ForwardRef as ReactComponent };